var map = {
	"./arrowDown.svg": 9497,
	"./arrowUp.svg": 3602,
	"./check.svg": 2578,
	"./dot.svg": 7110,
	"./frame.svg": 4487,
	"./leftArrow.svg": 1206,
	"./uberBlue.svg": 4225,
	"./uberDiamond.svg": 2041,
	"./uberGold.svg": 2679,
	"./uberPlatinum.svg": 5416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1929;